export function requiredById<T extends HTMLElement = HTMLElement>(id: string): T {
  const element = document.getElementById(id) as T | null;
  if (!element) {
    throw new Error(`Missing required DOM element: #${id}`);
  }
  return element;
}

export function requiredQuery<T extends HTMLElement = HTMLElement>(selector: string): T {
  const element = document.querySelector(selector) as T | null;
  if (!element) {
    throw new Error(`Missing required DOM element: ${selector}`);
  }
  return element;
}

export function optionalById<T extends HTMLElement = HTMLElement>(id: string): T | null {
  return document.getElementById(id) as T | null;
}
